import { NgModule } from '@angular/core';
import { GroupByPipe } from './group-by';

@NgModule({
  declarations: [
    GroupByPipe
  ],
  imports: [ ],
  exports: [
    GroupByPipe
  ]
})
export class GroupByModule {}



// WEBPACK FOOTER //
// ./src/pipes/group-by/group-by.module.ts